export default __webpack_public_path__ + "static/media/ckd.2df80a62.png";